/**
 * 共通画面のルーティング設定
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import Home from '../views/Home.vue'

/**
 * 共通ページ群
 */
const commonRoutes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
]

export default commonRoutes
